<template>
    <UiModal ref="modal" :width="define.width" :height="define.height" :spacing="spacing" :close="false">
        <div
            class="absolute leading-[1] right-[20px] top-[20px] p-[4px] cursor-pointer transition duration-200 hover:text-main"
            @click="methods.close">
            <ui-icon class="text-[16px]" name="close2" />
        </div>

        <div class="text-center text-emphas text-[24px] leading-[40px] font-bold mb-[12px]" v-if="name">{{ name }}</div>
        <div class="flex items-center justify-center text-center text-[16px] leading-[22px]">
            <slot>{{ content }}</slot>
        </div>

        <div class="mt-[24px] flex justify-center" v-if="controls">
            <UiButton :class="css_button.cancel" :width="104" size="middle" @click="methods.close">{{ $t("Cancel") }}</UiButton>
            <UiButton class="ml-[20px]" :width="104" size="middle" @click="methods.confirm">{{ $t("Confirm") }}</UiButton>
        </div>
    </UiModal>
</template>

<script lang="ts" setup>
//* 组件库
import { UiButton, UiModal, UiIcon } from "various-ui";
//* 组件属性
import { ModuleEmits, ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css_button from "@/assets/style/src/button.module.less";

//* 组件属性注册
const emits = defineEmits(ModuleEmits);
const define = defineProps(ModulePropsOption);

//* 组合函数
const { nodes, methods } = useComposable(emits);
const { open, close } = methods;
const { modal } = nodes;

//* 组件属性导出
defineExpose({ open, close });
</script>
